import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  // { to: '/revival-night', label: 'Revival Night' },
  // { to: '/prophetic-school', label: 'Prophetic School' },
  { to: '/mentorship', label: 'Mentorship' },
  { to: '/nyc-launch', label: 'NYC Launch' },
  { to: '/about', label: 'About' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100/80">
      <div className="mx-auto w-full max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="flex h-[72px] items-center justify-between">
          {/* Brand - simple text logo like Lovy Elias */}
          <Link
            to="/"
            className="font-body text-[15px] sm:text-[17px] font-semibold tracking-[0.12em] text-gray-900 uppercase"
            data-testid="site-nav-brand-link"
          >
            Prophet Malluc
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-7 lg:gap-9">
            {NAV_LINKS.map(link => (
              <Link
                key={link.to}
                to={link.to}
                className={`font-body text-[13px] tracking-wide transition-colors duration-200 ${
                  location.pathname === link.to
                    ? 'text-gray-900 font-medium'
                    : 'text-gray-500 hover:text-gray-900'
                }`}
                data-testid={`site-nav-${link.label.toLowerCase().replace(/\s/g, '-')}-link`}
              >
                {link.label}
              </Link>
            ))}

            {/* Dark CTA button - temporarily hidden
            <Link to="/revival-night">
              <button
                className="h-9 px-5 bg-[#1a2332] text-white text-[12px] font-body font-medium tracking-wider rounded-sm hover:bg-[#0f1520] transition-colors duration-200"
                data-testid="site-nav-get-tickets-button"
              >
                Donate
              </button>
            </Link>
            */}
          </div>

          {/* Mobile menu */}
          <div className="md:hidden">
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="text-gray-700 h-9 w-9" data-testid="site-nav-mobile-open-button">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-72 bg-white border-l border-gray-100">
                <div className="flex flex-col gap-7 mt-12">
                  <Link
                    to="/"
                    onClick={() => setOpen(false)}
                    className="font-body text-base text-gray-900 tracking-wide"
                  >
                    Home
                  </Link>
                  {NAV_LINKS.map(link => (
                    <Link
                      key={link.to}
                      to={link.to}
                      onClick={() => setOpen(false)}
                      className="font-body text-base text-gray-900 tracking-wide"
                    >
                      {link.label}
                    </Link>
                  ))}
                  {/* Donate button temporarily hidden
                  <Link to="/revival-night" onClick={() => setOpen(false)}>
                    <button className="w-full h-11 bg-[#1a2332] text-white font-body text-sm font-medium tracking-wider rounded-sm">
                      Donate
                    </button>
                  </Link>
                  */}
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>
  );
}
